import { Grid } from "@mui/material";
import { Input } from "controls";
import React from "react";

const GeneralFields = ({ values, errors, fromMyAcc, handleInpChg }) => {
  return (
    <>
      <Grid item xs={12} className="!mt-[15px]">
        <span className="border-left uppercase font-semibold text-gray-500 pl-[8px]">
          User Information
        </span>
      </Grid>
      <Grid item xs={12} md={4}>
        <Input
          label="Full Name"
          name="fullName"
          required={true}
          value={values.fullName}
          error={errors.fullName}
          inputProps={{ maxLength: 255 }}
          onChange={handleInpChg}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Input
          label="Phone"
          name="phone"
          required={true}
          value={values.phone}
          error={errors.phone}
          inputProps={{ maxLength: 255 }}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Input
          label="Email"
          name="email"
          required={true}
          value={values.email}
          error={errors.email}
          inputProps={{ maxLength: 255 }}
          onChange={handleInpChg}
          disabled={fromMyAcc}
        />
      </Grid>
    </>
  );
};

export default GeneralFields;
